import { render, staticRenderFns } from "./addRecipient.vue?vue&type=template&id=de8267d8"
import script from "./addRecipient.vue?vue&type=script&lang=js"
export * from "./addRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports